export const isNavOpen = state => state.nav.isOpen;



// WEBPACK FOOTER //
// ./src/store/nav/selectors.js